import { useTranslation } from "react-i18next";
import { useUpdateCustomerMutation } from "../api/cartApi";
import { useMutationWithFeedback } from "../../../../common/hooks/hooks";

/**
 * A custom hook to encapsulate the logic for updating the customer's shipping address in the cart.
 */
export const useUpdateCustomer = () => {
  const { t } = useTranslation();
  const [updateCustomerMutation, mutationResult] = useUpdateCustomerMutation();

  const { trigger, isLoading: isUpdatingCustomer } = useMutationWithFeedback({
    mutation: [updateCustomerMutation, mutationResult],
    // No success message needed as the UI update is sufficient feedback
    errorMessages: {
      default: t(
        "feedback.cart.customer.updateCustomerError",
        "Failed to update customer. Please try again."
      ),
      // --- Custom Extension Errors ---
      woocommerce_rest_invalid_tckn: t(
        "feedback.cart.customer.tcknInvalidBackend",
        "TCKN validation failed."
      ),
      woocommerce_rest_invalid_vkn: t(
        "feedback.cart.customer.vknInvalidBackend",
        "VKN validation failed."
      ),
      // --- Standard WooCommerce Store API Errors ---
      woocommerce_rest_invalid_postcode: t(
        "feedback.cart.customer.invalidPostcodeBackend",
        "Invalid postcode."
      ),
      // The specific code returned inside rest_invalid_param
      invalid_postcode: t(
        "feedback.cart.customer.invalidPostcodeBackend",
        "Invalid postcode."
      ),
      woocommerce_rest_invalid_email: t(
        "feedback.cart.customer.invalidEmailBackend",
        "Invalid email."
      ),
      woocommerce_rest_invalid_address_state: t(
        "feedback.cart.customer.invalidStateBackend",
        "Invalid state/province."
      ),
      woocommerce_rest_missing_field: t(
        "feedback.cart.customer.missingFieldBackend",
        "Missing required field."
      ),
    },
  });

  const handleUpdateCustomer = trigger;

  return { handleUpdateCustomer, isUpdatingCustomer };
};
